<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("common.delete") }}</span>
        </v-card-title>
        <v-card-text>
          {{ $t("common.verify") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel()">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="red darken-1" text @click="confirmDelete()">
            {{ $t("common.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "DeleteDialog",

  props: ["dialog"],

  computed: {
    show: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    confirmDelete() {
      this.$emit("confirm-delete");
    },

    cancel() {
      this.$emit("cancel-dialog");
    },
  },
};
</script>
